import e, { css as i } from "styled-components";
import t from "../../utils/colors.js";
const n = i`
  font-size: 1rem;
  line-height: 24px;
  letter-spacing: -0.3px;
  ${(o) => o.decoration && `text-decoration: ${o.decoration}`}
`, c = e("p").withConfig({
  shouldForwardProp: (o) => !["fontWeight", "fontSize", "textAlign", "color"].includes(o)
})`
  ${n};
  font-weight: ${(o) => o.fontWeight || "normal"};
  font-size: ${(o) => o.fontSize || "16"}px;
  text-align: ${(o) => o.textAlign || "inherit"};
  color: ${(o) => o.color ? t[o.color] : t.blueGrey};
`;
export {
  c as Body,
  c as default
};
